import type { Group, Object as FabricObject } from 'fabric/fabric-impl';

/** Элементы «Состава», которые рисуют текст на табло. Аватар заменяется картинкой — шрифт ему не нужен. */
const TEXT_INDICATORS = new Set(['playerName', 'playerNumber']);

export interface CompositionFont {
  fontFamily?: string;
  fontWeight?: string | number;
}

const isGroup = (object: FabricObject): object is Group => object.type === 'group';

/**
 * Шрифт «Состава» задаётся на группе целиком и раскладывается по именам и номерам игроков:
 * их `data.fontFamily` / `data.fontWeight` читает реплейсер табло (`replacer-main.ts`, `createName`),
 * а текст внутри — превью в редакторе и подмена номера (`replaceText` переносит шрифт текста).
 */
export function applyCompositionFont(composition: Group, font: CompositionFont): void {
  const patch = Object.fromEntries(Object.entries(font).filter(([, value]) => value !== undefined));
  composition.data = { ...composition.data, ...patch };

  for (const block of composition.getObjects().filter(isGroup)) {
    for (const element of block.getObjects().filter(isGroup)) {
      if (!TEXT_INDICATORS.has(element.data?.indicator)) continue;
      element.data = { ...element.data, ...patch };
      for (const text of element.getObjects()) {
        if (text.type?.includes('text')) text.set(patch);
      }
    }
  }
}
